import { defineMessages } from "react-intl";

export default defineMessages({
  submit: {
    id: "creditCardForm.submit",
    defaultMessage: "Submit",
  },
});
